import axios from 'axios';
import {
	includeToken,
	checkTokenIsValid
} from '../interceptors';
import helpers from '../helpers';

const handleApi = axios.create({
	baseURL: process.env.VUE_APP_HANDLE_API
});

handleApi.interceptors.request.use(...includeToken);
handleApi.interceptors.request.use(...checkTokenIsValid);

export default {

	getNotificationsList: async (params) => {
		try {
			const response = await handleApi.get(
				'/api/notifications',
				{ params }
			);
			return response.data;
		} catch (error) {
			if (error?.response?.status !== 401) {
				helpers.handleRequestError(error);
			}
		}
	},

	getNotificationsUnreadCount: async () => {
		try {
			const response = await handleApi.get(
				'/api/notifications/unread-count'
			);
			return response.data;
		} catch (error) {
			if (error?.response?.status !== 401) {
				helpers.handleRequestError(error);
			}
		}
	},

	getNotificationsById: async (id) => {
		try {
			const response = await handleApi.get(
				`/api/notifications/${id}`
			);
			return response.data;
		} catch (error) {
			if (error?.response?.status !== 401) {
				helpers.handleRequestError(error);
			}
		}
	}
};
